import ImportarClienteModal from './ImportarClienteModal';

export default ImportarClienteModal;
